export default {
    "definedParticipantBenes": [
        {
            "lastName": "DB_PRIME_LAST_A",
            "firstName": "DB_PRIME_FIRST_A",
            "middleName": "M",
            "entityName": "",
            "beneCategory": "Person",
            "dateOfBirth": null,
            "designatedPercent": 1,
            "address": {
                "uniqueKey": null,
                "addressLine1": null,
                "addressLine2": null,
                "addressLine3": null,
                "city": null,
                "state": null,
                "zipCode9": null,
                "foreignZipCode": null,
                "countryCode": null,
                "countryName": null,
                "consumerName": null
            },
            "relationship": "Non-Spouse",
            "beneType": "Primary",
            "planName": "FLOWSERVE PENSION PLAN - LYNCHBURG UNION"
        },
        {
            "lastName": "DB_PRIME_LAST_A",
            "firstName": "DB_PRIME_FIRST_A",
            "middleName": "M",
            "entityName": "",
            "beneCategory": "Person",
            "dateOfBirth": null,
            "designatedPercent": 0.75,
            "address": {
                "uniqueKey": null,
                "addressLine1": null,
                "addressLine2": null,
                "addressLine3": null,
                "city": null,
                "state": null,
                "zipCode9": null,
                "foreignZipCode": null,
                "countryCode": null,
                "countryName": null,
                "consumerName": null
            },
            "relationship": "Non-Spouse",
            "beneType": "Secondary",
            "planName": "FLOWSERVE PENSION PLAN - LYNCHBURG UNION"
        },
        {
            "lastName": "DB_PRIME_LAST_A",
            "firstName": "DB_PRIME_FIRST_A",
            "middleName": "M",
            "entityName": "",
            "beneCategory": "Person",
            "dateOfBirth": null,
            "designatedPercent": 0.75,
            "address": {
                "uniqueKey": null,
                "addressLine1": null,
                "addressLine2": null,
                "addressLine3": null,
                "city": null,
                "state": null,
                "zipCode9": null,
                "foreignZipCode": null,
                "countryCode": null,
                "countryName": null,
                "consumerName": null
            },
            "relationship": "Non-Spouse",
            "beneType": "tertiary",
            "planName": "FLOWSERVE PENSION PLAN - LYNCHBURG UNION"
        },
        {
            "lastName": "DB_PRIME_LAST_A",
            "firstName": "DB_PRIME_FIRST_A",
            "middleName": "M",
            "entityName": "",
            "beneCategory": "Person",
            "dateOfBirth": null,
            "designatedPercent": 0.25,
            "address": {
                "uniqueKey": null,
                "addressLine1": null,
                "addressLine2": null,
                "addressLine3": null,
                "city": null,
                "state": null,
                "zipCode9": null,
                "foreignZipCode": null,
                "countryCode": null,
                "countryName": null,
                "consumerName": null
            },
            "relationship": "Non-Spouse",
            "beneType": "Secondary",
            "planName": "FLOWSERVE PENSION PLAN - CASH BALANCE"
        },
        {
            "lastName": "DB_PRIME_LAST_A",
            "firstName": "DB_PRIME_FIRST_A",
            "middleName": "M",
            "entityName": "",
            "beneCategory": "Person",
            "dateOfBirth": null,
            "designatedPercent": 1,
            "address": {
                "uniqueKey": null,
                "addressLine1": null,
                "addressLine2": null,
                "addressLine3": null,
                "city": null,
                "state": null,
                "zipCode9": null,
                "foreignZipCode": null,
                "countryCode": null,
                "countryName": null,
                "consumerName": null
            },
            "relationship": "Non-Spouse",
            "beneType": "Primary",
            "planName": "FLOWSERVE PENSION PLAN - CASH BALANCE"
        }
    ],
    "definedParticipantPendingBenes": [],
    "lastBeneUpdate": "2023-06-30T14:44:20.000+0000",
    "defaultMessageText": null
}
